import React, {useEffect, useState} from 'react';
import {Pagination} from "react-bootstrap";

const PaginationComponent = ({visiblePages, lastPage, onPageChanged, className = null}) => {
    const [page, setPage] = useState(0);

    useEffect(() => {
        if(lastPage < page)
        {
            setPage(0);
        }
    }, [lastPage]);

    if(lastPage < 1)
        return null;

    const handlePageChange = (page) =>
    {
        setPage(page);
        onPageChanged(page);
    }

    const handleFirst = () => handlePageChange(0);
    const handleLast = () => handlePageChange(lastPage);
    const handlePrev = () => handlePageChange(prev => Math.max(prev - 1, 0));
    const handleNext = () => handlePageChange(prev => Math.min(prev + 1, lastPage));

    let items = [];

    const pagesVisible = Math.max(3, visiblePages);
    const startPage = Math.max(0, Math.min(page - Math.floor(pagesVisible / 2), lastPage - pagesVisible + 1));
    const endPage = Math.min(lastPage, startPage + pagesVisible - 1);


    for (let number = startPage; number <= endPage; number++) {
        items.push(
            <Pagination.Item key={number} active={number === page} onClick={() => handlePageChange(number)}>
                {number + 1}
            </Pagination.Item>
        );
    }


    return (
        <Pagination className={`mb-0 ${className ? className : ''}`}>
            <Pagination.First onClick={handleFirst} disabled={page === 0} />
            <Pagination.Prev onClick={handlePrev} disabled={page === 0} />
            {items}
            <Pagination.Next onClick={handleNext} disabled={page === lastPage} />
            <Pagination.Last onClick={handleLast} disabled={page === lastPage} />
        </Pagination>
    );
};

PaginationComponent.defaultProps = {
    visiblePages: 5,
    onPageChanged: (page) => {}
}

export default PaginationComponent;